
import Footer from "../Components/footer";
import Header from "../Components/Header";
import Form from "../Components/Form";

import Faqaccordian from '../Components/Faqaccordian';

import NewForm from "../Components/NewForm";
import CardSwiperSlider from "../Components/CardSwiperSlider";
import GoogleReviewsWidget2 from "../Components/GoogleReviewsWidget2";
import MoSlider from "../Components/MoSlider";
import { Helmet } from "react-helmet-async";
import CardSwiperSliderMobile from "../Components/CardSwiperSliderMobile";
import React, { useState} from 'react';
import { useNavigate } from "react-router-dom";


const Digitalmarketing = () => {


const sec5dot1 = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/sec5dot1.png";
const sec5dot2 = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/sec5dot2.png";
const sec5dot3 = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/sec5dot3.png";
const sec5dot4 = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/sec5dot4.png";
const stagesbg = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/stagesbg.png";


const imagesCard = [
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/web-card1.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/web-card2.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/web-card3.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/web-card4.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/web-card5.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/web-card6.svg",

  
];
const MobileimagesCard = [
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard1.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard2.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard3.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard4.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard5.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard6.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard8.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard9.svg",
  "https://d3vqz9qyn2r1xe.cloudfront.net/imges/DeskCard10.svg",

 
];

const slidesData = [

{
  id: 1,
  title: "Salon at Home – Book Your Appointment for a Luxurious Experience!",
  description:"Enjoy a premium salon experience in the comfort of your home. Our expert beauticians bring top-quality services, from hairstyling and facials to manicures, pedicures, and more—tailored to your needs.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img1.png", 
  bgcolor: 'rgba(255, 60, 115, 1)',
  btntext:'Visit Now',
  url:'https://www.lookplex.com/'
},
{
  id: 2,
  title: "Global Medical Community App",
  description:"A collaborative platform where doctors, medical professionals, and patients connect, share case studies, and manage health records in one place.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img2.png", 
  bgcolor: 'rgba(0, 52, 164, 1)',
  btntext:'Download Now',
  url:'https://www.smartcare.health/'
},
{
  id: 3,
  title: "Appointment Booking & Queue Management App",
  description:"Effortlessly find and book services—doctors, salons, restaurants, spas—near you, all while skipping the wait with real-time queue updates.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img3.png", 
  bgcolor: 'rgba(0, 161, 163, 1)',
  btntext:'Download Now'
},
{
  id: 4,
  title: "Journey of Miles: Tour & Travel App",
  description:"Explore and book curated travel packages across India. From hidden gems to popular destinations, plan your next adventure with ease.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img4.png", 
  bgcolor: 'rgba(46, 155, 95, 1)',
  btntext:'Visit Now'
},
{
  id: 5,
  title: "Book Doctor Appointments Effortlessly – Anytime, Anywhere!",
  description:"Say goodbye to long waiting times and complicated booking processes! Our doctor appointment booking software makes it quick and easy to schedule consultations with trusted healthcare professionals.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img5.png", 
  bgcolor: 'rgba(0, 163, 255, 1)',
  btntext:'Download Now'
},
{
  id: 6,
  title: "Clinic Management App",
  description:"Streamline your medical practice with comprehensive scheduling, patient record management, and secure communication—all in one user-friendly app.",
  bgimage: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-img6.png", 
  bgcolor: 'rgba(14, 39, 187, 1)',
  btntext:'Download Now'
},
];

const ratings = [
  {
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img2.svg",
    rating: 4.9,
  },
  {
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/clutch_img1.svg",
    rating: 4.8,
  },
  {
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img3.svg",
    rating: 4.6,
  },
  {
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/mob-add-img.png",
    rating: 4.4,
  },
  {
    img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/google-mo1.png",
    rating: 4.8,
  },
];




    // ================ Mailer code start from here =====================
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
        phone: "",
      });
      const [responseMessage, setResponseMessage] = useState(""); 
      const [loading, setLoading] = useState(false); // State for loader
      const navigate = useNavigate(); // Initialize useNavigate
      const [errors, setErrors] = useState({}); 
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value,
        });
      };
    
     
      const validateForm = () => {
        let formErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^[0-9]{10}$/; // Assumes phone number should be 10 digits
    
        if (!formData.email || !emailRegex.test(formData.email)) {
          formErrors.email = "Please enter a valid email address.";
        }
    
        if (!formData.phone || !phoneRegex.test(formData.phone)) {
          formErrors.phone = "Please enter a valid 10-digit phone number.";
        }
    
        if (!formData.message || formData.message.trim().length < 10) {
            formErrors.message = "Please enter a message with at least 10 characters.";
          }
    
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!validateForm()) {
          return;
        }
        setLoading(true); // Show loader
    
        try {
          const response = await fetch(
            "https://mailer.datametricks.com/send-email.php",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            }
          );
    
          const result = await response.json(); // Parse JSON from the response
    
          setResponseMessage(result.message);
    
          if (result.status === "success") {
            setTimeout(() => {
              setLoading(false); // Hide loader
              navigate("/Successemailpage"); // Redirect to Thank You page
            }, 1000); // Delay redirect by 2 seconds
          } else {
            setLoading(false); // Hide loader if not successful
          }
        } catch (error) {
          setResponseMessage("Error submitting form.");
          setLoading(false); // Hide loader on error
        }
      };
    
      // ================ Mailer code end here =====================


 const ratingstar = "https://d3vqz9qyn2r1xe.cloudfront.net/imges/ratingstar.svg";



 
var faqDataweb=[
  {que1:"1. What digital marketing services do you offer?",ans1:"We offer a wide range of digital marketing services, including: (i) Search Engine Optimization (SEO) (ii) Pay-Per-Click (PPC) Advertising (iii) Content Marketing (iv) Social Media Marketing (v) Email Marketing (vi) Web Analytics and Reporting , We can tailor a custom strategy to meet your specific needs and budget." },
  {que1:"2. How long does it take to see results from digital marketing? ", ans1:"The timeline for seeing results varies depending on several factors, including your industry, competition, budget, and the specific services you're using. However, with our data-driven approach and proven strategies, you can typically expect to see noticeable improvements in your online visibility and traffic within a few months."},
  {que1:"3. How do you measure the success of your digital marketing campaigns? ",ans1:"We believe in transparency and accountability. We use various metrics to track the success of our campaigns, including website traffic, lead generation, conversions, click-through rates, and return on investment (ROI). We provide regular reports and insights so you can see the impact of our efforts."},
  {que1:"4. What is your pricing structure for digital marketing services? ",ans1:"Our pricing is customized to fit your unique needs and goals. We offer flexible packages that can be tailored to your budget and specific requirements. Contact us for a free consultation to discuss your options. "},
  {que1:"5. How do i get started with your digital marketing services? ",ans1:"Getting started is easy! Simply contact us through our website or give us a call. We'll schedule a free consultation to discuss your business goals and how we can help you achieve them through digital marketing. "},
]

  return (
 
    <div>

    <Helmet>
        <title>Expert Website Development Services | Custom Web  Apps | DataMetricks</title>
        <meta name="description" content="Transform your vision into powerful website with our expert team. Specializing in iOS, Android & cross-platform solutions. Contact us today" />
      </Helmet>


        <section>
                <Header/>
               
        </section>


        <section >
            <div   style={{backgroundColor:'rgba(217, 235, 252, 1)'}}>
                <div className="container" style={{paddingBottom:'35px'}}>


                    <div className="row justify-content-center paddingt-35" style={{paddingTop:'10%'}}>
                        <div className="col-lg-7 col-12">
                        <p className="fw-800 fs-55 plus mb-0  font-28 lineheight" style={{color:'rgba(0, 83, 154, 1)',lineHeight:'72px'}}>Boost Your Brand with Results Driven Digital Marketing </p>

                            <p className="fw-500 fs-17 plus pt-lg-4 pt-20 hideinmo pe-4" style={{color:'rgba(0, 0, 0, 0.7)'}}> From SEO to social media, we craft custom strategies that attract, engage, and convert your ideal customers. <span className="fs-18 fw-700" style={{color:'rgba(0, 83, 154, 1)'}}>Contact us now! </span></p>

               <div className="hideinmo">
                <p className="fs-20 fw-700 plus pt-3" style={{color:'rgba(0, 83, 154, 1)'}}>Our Impact and Recognition</p>


<div className="row gap-3 mt-lg-5">
  {ratings.map((item, index) => (
    <div key={index} className="col-md-2 col-6 d-flex justify-content-center">
      <div
        className="d-flex flex-column align-items-center "
        style={{
          width: "150px",
          height: "180px",
        
        }}
      >
        <img
          src={item.img}
          alt="rating-img"
          className="img-fluid"
          style={{ width: "100%", height: "100px", objectFit: "contain" }}
        />

        <div className="mt-2 d-flex align-items-center justify-content-center">
          <span className="fs-5 fw-bold text-dark">{item.rating}</span>
          <img
            src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png"
            alt="star-icon"
            style={{ width: "60px", marginLeft: "5px" }}
          />
        </div>
      </div>
    </div>
  ))}
</div>

              


               </div>
                        </div>


                        <div className="col-lg-5 col-12  mt-10">

                     
                          <div className="d-flex mt-lg-4">
                            <div>
                              <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/meta-icon-line.svg" alt="" className="width150"  style={{height:'70px'}} />
                            </div>
                            <div>
                                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/google-icon-line.svg" alt="" className="width150" style={{height:'70px'}}    />

                            </div>
                            <div>
                               <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/linkedin-icon.svg" alt="" className="" style={{height:'70px'}}   />

                            </div>
                          </div>

                          <div className="hideinmo mt-4 ">
                          <form onSubmit={handleSubmit}>
                            <div className="px-4 pt-3 pb-4" style={{boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)', backgroundColor:'rgba(244, 250, 255, 1)',borderRadius:'24px'}}>
                               <p className="fs-28 fw-700 pop mb-0 font-20" style={{color:'rgba(27, 27, 27, 1)'}}>Ready to Start Your Project?</p>
                               <p className="fw-700 fs-25 pop pt-1 font-20" style={{color:'rgba(0, 83, 154, 1)'}}>Get a Free Quote</p>

                               <div >
                                <input className="w-100"
                                
                                type="text" placeholder="Name*" 
                                id="fname"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              required
                                style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                               </div>

                    <div className="mt-4 row">
                      <div className="col-md-6">
                               <div >
                                <input className="w-100" type="tel"
                                  name="phone"  
                                  value={formData.phone}
                                  onChange={handleChange}  
                                  required                
                                  placeholder="Mobile Number*" style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                                  {errors.phone && (
                        <p
                          className="error-text"
                          style={{
                            fontSize: "12px",
                            color: "red",
                            marginTop: "10px",
                          }}
                        >
                          {errors.phone}
                        </p>
                      )}
                               </div>
                               </div>

                               <div className="col-md-6">

                               <div >
                                <input className="w-100" type="email"
                                 id="email" name="email"  value={formData.email}
                                 onChange={handleChange}
                                 required
                                placeholder="Email*" style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                           {errors.email && <p className="error-text" style={{ fontSize: "12px", color: "red", marginTop: "5px" }}>{errors.email}</p>}

                               </div>
                               </div>

                               </div>

                               <div className="mt-4" >
                                <input className="w-100" type="text" placeholder="Message..."
                                 name="message"  value={formData.message}
                                 onChange={handleChange}
                                 form="usrform"
                                 required
                                style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                         {errors.message && (<p className="error-text" style={{ fontSize: "12px", color: "red", marginTop: "5px" }} > {errors.message} </p>)}

                               </div>
                          
                               <div className="mt-5" >
                               <button type="submit" className="btn btn-sm w-100" disabled={loading} style={{fontSize:'20px',fontWeight:'600',backgroundColor:'rgba(27, 27, 27, 1)',color:'white',borderRadius:'50px',border:'none',outline:'none',padding:'12px 60px 12px 60px'}}>
                        {loading ? (
                                    <>
            
                         <div className="spinner"></div>
                
                              </>
                          ) : (
                                "Submit"
                              )}

                         </button>
                               </div>
                            </div>
                          </form>
                          </div>

                      

                           
                          <div className="hideindesktop mt-30">
                          <form onSubmit={handleSubmit}>
                            <div className="px-4 pt-3 py-4" style={{boxShadow:'0px 0px 4px 0px rgba(0, 0, 0, 0.25)', backgroundColor:'rgba(244, 250, 255, 1)',borderRadius:'24px'}}>
                               <p className="fs-28 fw-700 pop mb-0 font-22" style={{color:'rgba(27, 27, 27, 1)'}}>Ready to Start Your Project?</p>
                               <p className="fw-700 fs-25 pop pt-1 font-20" style={{color:'rgba(0, 83, 154, 1)'}}>Get a Free Quote</p>

                               <div >
                                <input className="w-100"
                                
                                type="text" placeholder="Name*" 
                                id="fname"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              required
                                style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                               </div>

                    <div className="mt-4 row">
                      <div className="col-md-6">
                               <div >
                                <input className="w-100" type="tel"
                                  name="phone"  
                                  value={formData.phone}
                                  onChange={handleChange}  
                                  required                
                                  placeholder="Mobile number*" style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                                  {errors.phone && (
                        <p
                          className="error-text"
                          style={{
                            fontSize: "12px",
                            color: "red",
                            marginTop: "10px",
                          }}
                        >
                          {errors.phone}
                        </p>
                      )}
                               </div>
                               </div>

                               <div className="col-md-6 pt-4">

                               <div >
                                <input className="w-100" type="email"
                                 id="email" name="email"  value={formData.email}
                                 onChange={handleChange}
                                 required
                                placeholder="Email*" style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                           {errors.email && <p className="error-text" style={{ fontSize: "12px", color: "red", marginTop: "5px" }}>{errors.email}</p>}

                               </div>
                               </div>

                               </div>

                               <div className="mt-4" >
                                <input className="w-100" type="text" placeholder="Message..."
                                 name="message"  value={formData.message}
                                 onChange={handleChange}
                                 form="usrform"
                                 required
                                style={{border:'none',backgroundColor:'none',background:'none', boxShadow:'none',outline:'none', borderBottom:'1px solid rgba(184, 191, 182, 0.55)'}}/>
                         {errors.message && (<p className="error-text" style={{ fontSize: "12px", color: "red", marginTop: "5px" }} > {errors.message} </p>)}

                               </div>
                          
                               <div className="mt-4" >
                               <button type="submit " className="btn btn-sm w-100" disabled={loading} style={{fontSize:'20px',fontWeight:'600',backgroundColor:'rgba(27, 27, 27, 1)',color:'white',borderRadius:'50px',border:'none',outline:'none',paddingBottom:'6px'}}>
                        {loading ? (
                                    <>
            
                         <div className="spinner"></div>
                
                              </>
                          ) : (
                                "Submit"
                              )}

                         </button>
                               </div>
                            </div>
                          </form>
                          </div>

                         
                          
                        </div>
                       
                       
                    </div>

                    <div className="hideindesktop">
  <p
    className="fs-20 fw-700 plus pt-3"
    style={{ color: "rgba(0, 83, 154, 1)" }}
  >
    Our Impact and Recognition
  </p>
  <div
    className="d-flex justify-content-between align-items-center mt-3"
    style={{ gap: "10px" }} 
  >
    {/* Box 1 */}
    <div className="text-center">
      <img
        src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-logo1.png"
        alt="box-img"
        className="img-fluid"
        style={{ width: "60px", height: "60px", objectFit: "contain" }} 
      />
      <div className="fs-14 fw-700" style={{ color: "rgba(58, 58, 58, 1)" }}>
        4.9{" "}
        <img
          src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png"
          alt="star"
          style={{ width: "50px", height: "auto" }}
        />
      </div>
    </div>

    {/* Box 2 */}
    <div className="text-center">
      <img
        src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-logo2.png"
        alt="box-img"
        className="img-fluid"
        style={{ width: "60px", height: "60px", objectFit: "contain" }}
      />
      <div className="fs-14 fw-700" style={{ color: "rgba(58, 58, 58, 1)" }}>
        4.8{" "}
        <img
          src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png"
          alt="star"
          style={{ width: "50px", height: "auto" }}
        />
      </div>
    </div>

    {/* Box 3 */}
    <div className="text-center">
      <img
        src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-logo3.png"
        alt="box-img"
        className="img-fluid"
        style={{ width: "60px", height: "60px", objectFit: "contain" }}
      />
      <div className="fs-14 fw-700" style={{ color: "rgba(58, 58, 58, 1)" }}>
        4.6{" "}
        <img
          src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png"
          alt="star"
          style={{ width: "50px", height: "auto" }}
        />
      </div>
    </div>

    {/* Box 4 */}
    <div className="text-center">
      <img
        src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-logo4.png"
        alt="box-img"
        className="img-fluid"
        style={{ width: "60px", height: "60px", objectFit: "contain" }}
      />
      <div className="fs-14 fw-700" style={{ color: "rgba(58, 58, 58, 1)" }}>
        4.8{" "}
        <img
          src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png"
          alt="star"
          style={{ width: "50px", height: "auto" }}
        />
      </div>
    </div>
  </div>
</div>

                </div>
              
            </div>
        </section>


<section>
  <div className="d-flex align-items-center justify-content-center p-4" style={{backgroundColor:'rgba(247, 247, 247, 1)',overflow:'hidden'}}>
    <div>
      <p className="fw-400 fs-20 plus text-center ">In today’s digital-first world, your business needs more than just a website it needs a strong online presence. At Datametricks, we offer comprehensive digital marketing services in India designed to help businesses grow, engage, and succeed in the competitive online space.</p>
    </div>


  </div>
</section>
      

        <section>
            <div className="container mt-lg-4 mt-20">
                <div className="row justify-content-center">

                    <div className="col-lg-8">
                <p className="fw-800 fs-40 plus text-center font-25">Our Digital Marketing Solutions Include</p>
                {/* <p className="fs-18 fw-400 plus text-center" style={{color:'rgba(0, 0, 0, 0.6)'}}>Partner with India’s top website development company to create websites that stand out. Here’s why  you should choose us:</p> */}
                </div>

                </div>

                <div className="row justify-content-center  mt-lg-3 g-0 g-2 pt-10">
                <div className="col-lg-6 col-12 col-md-3">

                      <div className="px-4 py-3 h-100" style={{borderRadius:'12px',backgroundColor:'rgba(255, 255, 255, 1)', borderStyle: 'solid',borderWidth: '1px 1px 1px 1px',borderColor: '#DEE2E6',}}>
                            <div className="d-flex gap-2 align-items-center">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/ecomm-icon-new.svg" alt="" />
                                </div>
                                <div>
                                    <p className="fw-700 fs-18 plus font-15" style={{color:'rgba(0, 83, 154, 1)'}}>Search Engine Optimization (SEO)</p>
                                </div>
                           </div>
                           <p className="fw-500 fs-14 plus font-13 fw700 pt-3" style={{color:'rgba(0, 0, 0, 0.7)'}}>Rank higher on Google and other search engines. Our SEO strategies focus on keyword optimization, technical SEO, local SEO (perfect for Indian markets), and high-quality backlinks to bring you organic traffic.</p>
                       
                    </div>

                </div>

                        <div className="col-lg-6 col-12 col-md-3">

                        <div className="px-4 py-3 h-100" style={{borderRadius:'12px',backgroundColor:'rgba(255, 255, 255, 1)', borderStyle: 'solid',borderWidth: '1px 1px 1px 1px',borderColor: '#DEE2E6',}}>
                            <div className="d-flex gap-2 align-items-center">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/website-icon-new.svg" alt="" />
                                </div>
                                <div>
                                    <p className="fw-700 fs-18 plus font-15" style={{color:'rgba(0, 83, 154, 1)'}}>Social Media Marketing (SMM)</p>
                                </div>
                           </div>
                           <p className="fw-500 fs-14 plus font-13 fw700 pt-3" style={{color:'rgba(0, 0, 0, 0.7)'}}>Grow your brand across platforms like Instagram, Facebook, LinkedIn, and Twitter. We create engaging content, run targeted ad campaigns, and help you connect with your audience in meaningful ways.</p>
                       
                    </div>
                       
                        </div>
              
                 </div>

                 <div className="row justify-content-center g-0 g-2 " style={{paddingTop:'8px'}}>
                <div className="col-lg-6 col-12 col-md-3">

                      <div className="px-4 py-3 h-100" style={{borderRadius:'12px',backgroundColor:'rgba(255, 255, 255, 1)', borderStyle: 'solid',borderWidth: '1px 1px 1px 1px',borderColor: '#DEE2E6',}}>
                            <div className="d-flex gap-2 align-items-center">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/static-icon-new.svg" alt="" />
                                </div>
                                <div>
                                    <p className="fw-700 fs-18 plus font-15" style={{color:'rgba(0, 83, 154, 1)'}}>Google Ads (PPC Management)</p>
                                </div>
                           </div>
                           <p className="fw-500 fs-14 plus font-13 fw700 pt-3" style={{color:'rgba(0, 0, 0, 0.7)'}}>Drive instant traffic with pay-per-click advertising. From keyword research to ad copy and bid management, we ensure your ad spend delivers maximum ROI.</p>
                       
                    </div>

                </div>

                        <div className="col-lg-6 col-12 col-md-3">

                        <div className="px-4 py-3 h-100" style={{borderRadius:'12px',backgroundColor:'rgba(255, 255, 255, 1)', borderStyle: 'solid',borderWidth: '1px 1px 1px 1px',borderColor: '#DEE2E6',}}>
                            <div className="d-flex gap-2 align-items-center">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/responsive-icon-new.svg" alt="" />
                                </div>
                                <div>
                                    <p className="fw-700 fs-18 plus font-15" style={{color:'rgba(0, 83, 154, 1)'}}>Content Marketing</p>
                                </div>
                           </div>
                           <p className="fw-500 fs-14 plus font-13 fw700 pt-3" style={{color:'rgba(0, 0, 0, 0.7)'}}>We craft impactful content—blogs, videos, infographics, and more—that informs, engages, and converts your audience while supporting your SEO and branding goals.</p>
                       
                    </div>
                       
                        </div>
              
                 </div>

                 <div className="row justify-content-center g-0 g-2 " style={{paddingTop:'8px'}}>
                <div className="col-lg-6 col-12 col-md-3">

                      <div className="px-4 py-3 h-100" style={{borderRadius:'12px',backgroundColor:'rgba(255, 255, 255, 1)', borderStyle: 'solid',borderWidth: '1px 1px 1px 1px',borderColor: '#DEE2E6',}}>
                            <div className="d-flex gap-2 align-items-center">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/dynamic-icon-new.svg" alt="" />
                                </div>
                                <div>
                                    <p className="fw-700 fs-18 plus font-15" style={{color:'rgba(0, 83, 154, 1)'}}>Email Marketing</p>
                                </div>
                           </div>
                           <p className="fw-500 fs-14 plus font-13 fw700 pt-3" style={{color:'rgba(0, 0, 0, 0.7)'}}>Reach your audience directly with smart email campaigns. From newsletters to product promotions, we help you stay top-of-mind and drive conversions.</p>
                       
                    </div>

                </div>

                        <div className="col-lg-6 col-12 col-md-3">

                        <div className="px-4 py-3 h-100" style={{borderRadius:'12px',backgroundColor:'rgba(255, 255, 255, 1)', borderStyle: 'solid',borderWidth: '1px 1px 1px 1px',borderColor: '#DEE2E6',}}>
                            <div className="d-flex gap-2 align-items-center ">
                                <div>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/custom-icon-new.svg" alt="" />
                                </div>
                                <div>
                                    <p className="fw-700 fs-18 plus font-15" style={{color:'rgba(0, 83, 154, 1)'}}>Online Reputation Management (ORM)</p>
                                </div>
                           </div>
                           <p className="fw-500 fs-14 plus font-13 fw700 pt-3" style={{color:'rgba(0, 0, 0, 0.7)'}}>Build trust and credibility online. We monitor, manage, and improve your brand’s image across review platforms, search engines, and social media</p>
                       
                    </div>
                       
                        </div>
              
                 </div>


            <div className="text-center mt-4">
             <a href="#formsection" >   <button className="btn btn-sm px-5 py-3 mt-3" style={{border:'1px solid rgba(189, 189, 189, 1)',borderRadius:'7px'}}>
                                <div className="d-flex align-items-center justify-content-center w-100">
                                    <p className="fw-500 fs-17 plus m-0" style={{color:'rgba(0, 83, 154, 1)'}}>Get a Free Quote</p>
                                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/right-web-arrow.svg" alt="" className="ms-2" />
                                </div>
                            </button> </a> 
                            </div>
               
            </div>

        </section>
 
    
<section>

<div className="container my-lg-5 mt-40">
              <h1 className="text-center mb-4 fw-800 plus fs-40 font-25">Why Choose Us?</h1>

        <div className="row mt-lg-5 mt-30 justify-content-center ">

            <div className="col-md-3 text-end">
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/healthomax-new.svg" alt="" className="img-fluid h100" style={{height:'400px'}}  />
            </div>

            <div className="col-md-8 mt-20">
                <div className=" rounded-4 p-lg-4 p-10 text-center " style={{border:'1px solid rgba(223, 223, 223, 1)'}}>
                    <div className="row g-2">
                        <div className="col-md-6">
                            <div className=" rounded-2 p-4 text-center  h-100" style={{border:'1px solid rgba(223, 223, 223, 1)'}}>
                                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Tailored.svg" alt="Icon 1" width="60" className="mb-3" />
                                <h6 className="fs-18 fw-600 plus mb-0" style={{color:'rgba(0, 0, 0, 1)'}}>Tailored Strategies for Indian Markets</h6>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className=" rounded-2 p-4 text-center  h-100" style={{border:'1px solid rgba(223, 223, 223, 1)'}}>
                                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Driven.svg" alt="Icon 2" width="60" className="mb-3" />
                                <h6 className="fs-18 fw-600 plus mb-0" style={{color:'rgba(0, 0, 0, 1)'}}>Data-Driven Campaigns with Real Time Reporting</h6>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className=" rounded-2 p-4 text-center  h-100" style={{border:'1px solid rgba(223, 223, 223, 1)'}}>
                                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Transparent.svg" alt="Icon 3" width="60" className="mb-3" />
                                <h6 className="fs-18 fw-600 plus mb-0" style={{color:'rgba(0, 0, 0, 1)'}}>Transparent Communication & Dedicated Support</h6>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className=" rounded-2 p-4 text-center  h-100" style={{border:'1px solid rgba(223, 223, 223, 1)'}}>
                                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Experience.svg" alt="Icon 4" width="60" className="mb-3" />
                                <h6 className="fs-18 fw-600 plus mb-0" style={{color:'rgba(0, 0, 0, 1)'}}>Experience Across Multiple Industries</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>



</section>


<section>
  <section className="mt-30">
  <div className="container text-center">
    <h2 className="fs-40 fw-700 plus font-25">Industry-Specific Digital Solutions</h2>
    <p className="fs-21 fw-400 plus font-18" style={{color:'rgba(0, 0, 0, 0.6)'}}>We offer targeted digital strategies across various sectors in India</p>

   
    <div className="row g-2 justify-content-center mt-lg-5 mt-30">
    
      <div className="col-lg-5 col-6 ">
        <div className="small-card-new">
          <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/tech-new.png" alt="Tech Startups" />
          <div className="card-title-overlay-new plus">Tech Startups</div>
        </div>
      </div>


       <div className="col-lg-5 col-6 ">
        <div className="small-card-new">
          <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/hospital-new.png" alt="Tech Startups" />
          <div className="card-title-overlay-new plus">Hospitality & Travel</div>
        </div>
      </div>

        <div className="col-lg-5 col-6 ">
        <div className="small-card-new">
          <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/healthcare-new.png" alt="Tech Startups" />
          <div className="card-title-overlay-new plus">Healthcare & Clinics</div>
        </div>
      </div>


       <div className="col-lg-5 col-6 ">
        <div className="small-card-new">
          <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/ecommerce-new.png" alt="Tech Startups" />
          <div className="card-title-overlay-new plus">E-Commerce & D2C</div>
        </div>
      </div>

      
        <div className="col-lg-5 col-6 ">
        <div className="small-card-new">
          <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/education-new.png" alt="Tech Startups" />
          <div className="card-title-overlay-new plus">Education & EdTech</div>
        </div>
      </div>


       <div className="col-lg-5 col-6 ">
        <div className="small-card-new">
          <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/legal-new.png" alt="Tech Startups" />
          <div className="card-title-overlay-new plus ">Legal & Finance</div>
        </div>
      </div>
     
    </div>
  </div>
</section>
</section>









<section>
                <div className="container mt-40 mt-5">
                    <p className="fs-25 fw-600 plus text-center mb-0" style={{color:'rgba(0, 83, 154, 1)'}}>Our Pratners</p>
                    <p className="fw-700 fs-35 plus text-center mt-2" >We work with the best partners </p>
                    <div className="row justify-content-center ">
                        <div className="col-lg-10">
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/our-partner.svg" alt="" className="img-fluid mt-4" />
                        </div>

                    </div>
                </div>

            </section>
    





    <section>
  <div className="container  mt-10" style={{marginTop:'60px'}}>
    <div className="row justify-content-center align-items-center">
      <div className="col-lg-5 textcenter">
        <p className="fs-40 fw-800 plus font-25" style={{color:'rgba(0, 83, 154, 1)'}}>What Makes DataMetricks Stand Out?</p>
        <a href="#formsection">
                    <button type="button" className="btn btn-sm font-14    px-4" style={{fontSize:'18px',fontWeight:'700',borderRadius:'45px',border:'1.5px solid rgba(0, 83, 154, 1)',outline:'none',color:'rgba(0, 83, 154, 1)'}}>
                    Get a Free Quote
                    </button>
         </a>
      </div>


      <div className="col-lg-6 mt-30">
        <div className="row g-2 ">
          <div className="col-md-6">
            <div className="pt-3 pb-1 px-4 h-100" style={{backgroundColor:'rgba(255, 235, 226, 1)',borderRadius:'27px'}}>
                <p className="fw-600 fs-20 plus mb-0">Successful Projects</p>
                <p className="fs-16 fw-400 plus pt-2 mb-0" style={{color:'rgba(0, 0, 0, 0.7)'}}>Proven track record of delivering high-quality solutions across various industries.</p>
                <p className="fw-800 fs-40 plus pt-1 font-25" style={{color:'rgba(180, 84, 40, 1)'}}>100+</p>
            </div>

          </div>
          <div className="col-md-6">
            <div className="pt-3 pb-1 px-4 h-100" style={{backgroundColor:'rgba(232, 252, 255, 1)',borderRadius:'27px'}}>
                <p className="fw-600 fs-20 plus mb-0">Skilled Developers</p>
                <p className="fs-16 fw-400 plus pt-2 mb-0" style={{color:'rgba(0, 0, 0, 0.7)'}}>A dedicated team of professionals with expertise in cutting-edge technologies.</p>
                <p className="fw-800 fs-40 plus pt-1 font-25" style={{color:'rgba(62, 156, 170, 1)'}}>30+</p>
            </div>

          </div>

        </div>

        <div className="row pt-2">
          <div className="col-md-12">
            <div className="pt-3 pb-1 px-4 " style={{backgroundColor:'rgba(240, 250, 240, 1)',borderRadius:'27px'}}>
                <p className="fw-600 fs-20 plus mb-0">Client Satisfaction</p>
                <p className="fs-16 fw-400 plus pt-2 mb-0" style={{color:'rgba(0, 0, 0, 0.7)'}}>Commitment to excellence, ensuring top-tier service and customer success.</p>
                <p className="fw-700 fs-40 plus pt-1 font-25" style={{color:'rgba(93, 169, 93, 1)'}}>4.8 Google Ratings</p>
            </div>
          </div>
          </div>

</div>

    </div>

  </div>
</section>





<section>
  <div className="container my-5">
    <p className="fs-35 fw-800 plus text-center font-25" style={{color:'rgba(26, 26, 26, 1)'}}>Industry - Leading Technologies We Utilized</p>
<div className="row justify-content-center">
  <div className="col-lg-8">
    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/TechStack-img.png" alt="" className="img-fluid mt-4" />

  </div>
</div>
  </div>
</section>


         
    

     


        <section className=" mt-lg-5 mt-30" >
    <div className="container pb-lg-5 ">
        <p className="fw-800 fs-35 plus text-center mb-0 font-23" style={{color:'#1B3567'}}>India's One Of The Highest Rated Website Development Company</p>
        <p className="fw-500 fs-20 plus text-center pt-2 font-18" style={{color:'#1B3567'}}> 100+ Glowing 5-Star Reviews Across Top B2B Review Platforms</p>

        <div className="row justify-content-center mt-4 g-2 p-10" >

            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100" style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/clutch_img1.svg" alt="box-img" style={{height:'100px',width:'100%'}} className="img-fluid  "  />
                    {/* <img src={ratingstar} alt="" className="pt-2  "  /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.8</p>
                                  

                </div>
            </div>
            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100" style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img2.svg" alt="box-img" style={{height:'100px',width:'100%'}} className="img-fluid  "  />
                    {/* <img src={ratingstar} alt="" className="pt-2  "   /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.9</p>
                                  

                </div>
            </div>

            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100" style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img3.svg" alt="box-img" style={{height:'100px',width:'100%'}} className="img-fluid heightwidth2" />
                    {/* <img src={ratingstar} alt="" className="pt-2"  /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.6</p>
                </div>
            </div>

            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100" style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-img4.svg" alt="box-img" style={{height:'100px',width:'100%'}} className="img-fluid heightwidth2" />
                    {/* <img src={ratingstar} alt="" className="pt-2"  /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.4</p>
                </div>
            </div>

            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100 " style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Mo-logo4.png" alt="box-img" style={{height:'100px',width:'75%',objectFit:'contain'}} className="img-fluid  " />

                    {/* <img src={ratingstar} alt="" className="pt-2"   /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-lg-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.8</p>
                </div>
            </div>
            <div className="col-lg-2 col-md-2 col-6 text-center">
                <div className="p-2 h-100" style={{border:'1px solid #C7D6E3',borderRadius:'9px',backgroundColor:'#FFFFFF'}}>
                    
                    <div>
                        <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/mob-add-img.png" alt="box-img" style={{height:'100px',width:'75%',objectFit:'contain'}} className="img-fluid" />

                        </div>
                    {/* <img src={ratingstar} alt="" className="pt-2"  /> */}
                    <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/star-rating.png" alt="" className="pt-lg-2  "  style={{width:'110px'}} />

                    <p className="fw-700 fs-32 mont font-23 pt-2" >4.4</p>
                </div>
            </div>

          
        </div>

    </div>

</section>





    <section>
                <div className="container  mt-20">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-12 col-md-6">
                        <div className="text-center">
                                  <p className="fw-800 fs-33 plus font-23 " style={{color:'#1B3567'}}>What We Believe in</p>
                                {/* <p className="fw-500 fs-16 plus px-lg-5 " style={{color:'#000000',lineHeight:'30px'}}>We Committed To Delivering High-Quality Projects With a Strong Focus On On-Time Delivery. Our Team Prioritizes Efficient Workflows, Clear Communication, And Tailored Solutions To Ensure Every Project Is Completed Within The Agreed Timeline, Meeting And Exceeding Client Expectations</p> */}
                                <p className="fw-500 fs-16 plus " style={{color:'rgba(0, 0, 0, 0.6)',lineHeight:'25px'}}>We are committed to delivering high-quality projects with a strong focus on on-time delivery. Our team prioritizes efficient workflows, clear communication, and tailored solutions to ensure every project is completed within the agreed timeline, meeting and exceeding client expectations.</p>

                        </div>
                        </div>
                    </div>
                </div>
    </section>

            <section>
                <div className="container mt-4">
                    <div className="row g-2">
                        <div className="col-lg-3 col-12 col-md-6 textcenter">
                        <div className="box-shadow1 h-100">
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-icon2.svg" alt="" />
                            <p className="fw-800 fs-20 plus mb-0 mt-4" style={{color:'#00539A'}}>Security</p>
                            <p className="fw-500 plus fs-16 mt-3" style={{color:'#7C7C7C'}}>Our aim is to bring a new approach to secure your software based on integrity, trust and transparency</p>

                        </div>
                        </div>

                        <div className="col-lg-3 col-12 col-md-6 textcenter">
                        <div className="box-shadow1 h-100">
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-icon3.svg" alt="" />
                            <p className="fw-800 fs-20 plus mb-0 mt-4" style={{color:'#00539A'}}>Support</p>
                            <p className="fw-500 plus fs-16 mt-3" style={{color:'#7C7C7C'}}>The best gift is time, and our 24/7 dedicated support team is always available to address your queries and concerns.</p>

                        </div>
                        </div>

                        <div className="col-lg-3 col-12 col-md-6 textcenter">
                        <div className="box-shadow1 h-100">
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-icon4.svg" alt="" />
                            <p className="fw-800 fs-20 plus mb-0 mt-4" style={{color:'#00539A'}}>Integrity</p>
                            <p className="fw-500 plus fs-16 mt-3" style={{color:'#7C7C7C'}}>Our expert team offers the best advice tailored to your product. We ensure guidance that drives success.</p>

                        </div>
                        </div>

                        <div className="col-lg-3 col-12 col-md-6 textcenter">
                        <div className="box-shadow1 h-100">
                            <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/Lp-icon5.svg" alt="" />
                            <p className="fw-800 fs-20 plus mb-0 mt-4" style={{color:'#00539A'}}>Transparency</p>
                            <p className="fw-500 plus fs-16 mt-3" style={{color:'#7C7C7C'}}>Transparency means embracing new ideas, technology, and approaches. We firmly believe in fostering learning and openness.</p>

                        </div>
                        </div>
                    </div>
                </div>
            </section>



  <div id="formsection">

</div>

      
<section  className=" d-none d-sm-none d-md-block d-lg-block" style={{marginTop:'7%'}}>
   <NewForm/>

</section>

{/* Mobile View  */}
<section className="mt-lg-4 d-block d-sm-block d-md-none d-lg-none">
    <div className=" pt-3 pb-5 px-2 mt-30" style={{backgroundColor:'rgba(242, 242, 242, 1)'}}>
        <div className="container">
         
                      <p className="fw-600 text-center fs-23 plus mb-0 pt-1" >What can we help you with?</p>
                      <p className="fw-500 text-center fs-17 plus pt-3" style={{lineHeight:'22px'}}>Get Custom Solutions, Recommendations, or, Estimates.
                      Confidentiality & Same Day Response Guaranteed!</p>
    <div className="pt-1">
       <Form/>
    </div>

    <div className="d-flex justify-content-center gap-2 mt-4 ">

<div className="d-flex  gap-2">
    <div>
          <img src= "https://d3vqz9qyn2r1xe.cloudfront.net/imges/green-icon-form.svg" alt="" className="pt-1" />
    </div>
    <div>
           <p className="fw-600 plus fs-17  pt-1">100% Confidential</p>
    </div>
</div>

<div className="d-flex  gap-2">
    <div>
          <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/green-icon-form.svg" alt="" className="pt-1" />
    </div>
    <div>
           <p className="fw-600 plus fs-17  pt-1">We sign NDA</p>
    </div>
</div>

</div>

<div className="d-flex gap-4 mt-4">
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon1.svg" alt="" className="img-fluid" />
            </div>
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon2.svg" alt="" className="img-fluid" />
            </div>
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon3.svg" alt="" className="img-fluid pt-1" />
            </div>
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon4.svg" alt="" className="img-fluid" />
            </div>
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon5.svg" alt="" className="img-fluid" />
            </div>
            <div>
                <img src="https://d3vqz9qyn2r1xe.cloudfront.net/imges/formicon6.svg" alt="" className="img-fluid pt-2" />
            </div>
    </div>

      </div>
      </div>
</section>



{/* <section className="mt-5">
    <GoogleReviewsWidget/>
</section> */}

<section className="my-lg-5">
  <div className="container-fluid">
    <GoogleReviewsWidget2/>
    </div>
</section>






        <section style={{backgroundColor:'rgba(208, 233, 255, 1)'}}>
      <div className=" pt-5 pb-4">
          <Faqaccordian faqAccordianData={faqDataweb}/>
          </div>
      </section>



        <section >
                <Footer/>
        </section>

    </div>
  );
};
export default Digitalmarketing;
